



















































































































































import Component from "vue-class-component";
import RequestDate from "./fields/Date.vue";
import RequestTitle from "./fields/Title.vue";
import RequestAdvertiser from "./fields/Name.vue";
import RequestCreator from "./fields/Requester.vue";
import RequestCreatorDate from "./fields/UpdatedDate.vue";
import RequestStatus from "./fields/Status.vue";
import RequestType from "./fields/Type.vue";
import RequestNumber from "./fields/Number.vue";
import RequestDescription from "./fields/Description.vue";
import RequestTopic from "./fields/Topic.vue";
import RequestBudget from "./fields/Budget.vue";
import RequestAssigned from "./fields/Assigned.vue";
import HierarchyOwner from "./fields/HierarchyOwner.vue";
import StandardList from "front-component/components/List.vue";
import Http from "front-component/Http";
import _ from "lodash";
import {Prop, Watch} from "vue-property-decorator";
import RequestRepository from "@/repositories/request/RequestRepository";
import Orders from "@/components/miscellaneous/Orders.vue";
import {Getter} from "vuex-class";

const components = {
    RequestDate,
    RequestTitle,
    RequestCreator,
    RequestCreatorDate,
    RequestAdvertiser,
    RequestStatus,
    RequestType,
    RequestNumber,
    RequestDescription,
    RequestTopic,
    RequestBudget,
    RequestAssigned,
    Orders,
    HierarchyOwner,
};

@Component({ components })
export default class List extends StandardList {
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    protected route: string = "get_request";
    protected displayed: string = "";
    protected isSimplified: boolean = false;

    @Prop( { default: null }) public hiddenComponent !: string[];
    @Prop( { default: 50}) public limitPerPage !: number;
    @Prop( { default: false }) public showChildren !: boolean;

    public activeComponent(component: string) {
        return !_.includes(this.hiddenComponent, component);
    }

    public created() {
        this.fields = Http.computeStandardFields(components, "request");
    }

    public showChildrenLines(uuid: string) {
        this.displayed = (this.displayed === uuid ? "" : uuid);
    }

    @Watch("isSimplified") public switchList() {
        this.displayed = "";
        this.$emit("switch-list", this.isSimplified);
    }

    @Watch("elements") public elementsChange() {
        if (this.elements.length === 1) {
            this.displayed = _.get(this.elements[0], "uuid", "");
        }
    }

    @Watch("limitPerPage") public loadExport() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    protected link(): string {
        return RequestRepository.getSearchUrl();
    }

    private launchEdition(uuid: string) {
        this.$emit("show-request", {uuid});
    }
}
